import { LinearProgress, MenuItem, Toolbar, WithStyles, withStyles } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import * as React from "react";

import { getAvailableProductsForMe, getProductTitle, getProductUrl } from "../../helper/functions.helper";
import { User } from "../../models/User.model";
import { LogoColor } from "../Logo/LogoColor";
import { styles } from "./MenuNavBar.style";

type MenuNavBarProps = {
    user?: User;
    isLoading?: boolean;
    push(path: string);
    goToMyAdvisors?();
};

class MenuNavBar extends React.Component<MenuNavBarProps & WithStyles<typeof styles>> {
    // TODO check code

    state = {
        anchorEl: null,
    };

    public render() {
        const { classes } = this.props;
        const { anchorEl } = this.state;

        // TODO check path for product

        const handleClick = (event) => {
            this.setState({ anchorEl: event.currentTarget });
        };
        const handleClose = () => {
            this.setState({ anchorEl: null });
        };

        const isManager = this.props.user.advisors && this.props.user.advisors.length > 0;
        const products = getAvailableProductsForMe(this.props.user);

        return (
            <React.Fragment>
                <Toolbar className={classes.container}>
                    <div className={classes.logo} onClick={() => this.props.push("/")}>
                        <LogoColor size="small" company={this.props.user ? this.props.user.company : null} />
                    </div>
                    {isManager && (
                        <MenuItem className={classes.item} onClick={this.props.goToMyAdvisors}>
                            Mes commerciaux
                        </MenuItem>
                    )}
                    <MenuItem aria-owns={"menu-product"} onClick={handleClick} className={classes.item}>
                        Produits
                    </MenuItem>
                    <MenuItem className={classes.item} onClick={() => this.props.push("/quotations")}>
                        Propositions
                    </MenuItem>
                    <MenuItem className={classes.item} onClick={() => this.props.push("/customers")}>
                        Clients
                    </MenuItem>

                    <Menu
                        className={classes.menu}
                        id="menu-product"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {products.map((p, index) => (
                            <MenuItem
                                key={index}
                                className={classes.subitem}
                                onClick={() => this.handleMenuItemClick(getProductUrl(p.name, p.variant))}
                            >
                                {getProductTitle(p.name, p.variant)}
                            </MenuItem>
                        ))}
                    </Menu>
                </Toolbar>
                {this.props.isLoading && <LinearProgress className={classes.linearProgress} />}
            </React.Fragment>
        );
    }

    private handleMenuItemClick(path: string) {
        this.props.push(path);
        this.setState({
            anchorEl: null,
        });
    }
}

export default withStyles(styles)(MenuNavBar);



// WEBPACK FOOTER //
// ./src/components/MenuNavBar/MenuNavBar.tsx